export function formatKeyResultsMessage(message: string): string[] {
  return message
    .split('\n')
    .filter((message) => message.length > 0)
    .map((line) => line.replaceAll(';', '.').replaceAll('1.', '').replaceAll('2.', '').replaceAll('3.', '').trim())
}
